function Loader() {
    return ( 
        <div className="border-gray-300 h-14 w-14 animate-spin rounded-full border-4 border-t-indigo-600" />
     );
}

export default Loader;